import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  tableHead: {
    backgroundColor: '#022A5C !important'
  },
  tableHeadText: {
    color: '#FFFFFF !important',
    textAlign: 'center !important'
  },
  tableRowText: {
    color: '#1E5168',
    textAlign: 'center'
  },
  tableHeadSuperlogica: {
    backgroundColor: '#F5F5F5 !important'
  },
  tableHeadTextSuperlogica: {
    color: '#1E5168 !important',
    textAlign: 'center !important',
    height: '60px !important',
    padding: '0 !important'
  },
  tableRowSuperlogica: {
    backgroundColor: '#F5F5F5 !important'
  },
  clientAreaTable: {
    '& .MuiTableCell-body': {
      color: 'initial !important'
    }
  },
  loadAllButton: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#F5F5F5',
    border: '1px solid #D7D7D7',
    borderBottomLeftRadius: 5,
    borderBottomRightRadius: 5,
    padding: 10,
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#EBEBEB'
    }
  }
}));